import { render, staticRenderFns } from "./ProcessInstanceInfo.vue?vue&type=template&id=25c69b29&scoped=true"
import script from "./ProcessInstanceInfo.vue?vue&type=script&lang=js"
export * from "./ProcessInstanceInfo.vue?vue&type=script&lang=js"
import style0 from "./ProcessInstanceInfo.vue?vue&type=style&index=0&id=25c69b29&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c69b29",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VListItemContent,VProgressCircular})
